import { getAssetUrl } from '../../Common/Utils/assetUrl';

export const mapB2CTenantToLanding = (tenantData) => ({
  isPreview:   tenantData?.isPreview ?? false,
  companyId:   tenantData?.companyId,
  branchId:    tenantData?.branchId,
  userId:      tenantData?.userId,
  logoUrl:     getAssetUrl(tenantData?.branding?.logoUrl) || '/assets/images/logo.png',
  brandName:   tenantData?.branding?.brandName   || 'WanderTrips',
  companyName: tenantData?.branding?.companyName || 'WanderTrips',
  email:       tenantData?.branding?.email       || 'info@wandertrips.com',
  phones:      Array.isArray(tenantData?.branding?.phones)
               ? tenantData?.branding?.phones[0]
               : tenantData?.branding?.phones || '9000000000',
  whatsapp:    tenantData?.branding?.whatsapp || '9000000000',
  socials:     tenantData?.branding?.socials  || {},
  companyData: tenantData?.companyData        || {},
  seo:         tenantData?.seo               || {},
  themeColor1: tenantData?.theme?.themeColor1 || tenantData?.theme?.themecolor1,
  themeColor2: tenantData?.theme?.themeColor2 || tenantData?.theme?.themecolor2,
  themeColor3: tenantData?.theme?.themeColor3 || tenantData?.theme?.themecolor3,
  themeColor4: tenantData?.theme?.themeColor4 || tenantData?.theme?.themecolor4,
  themeColor5: tenantData?.theme?.themeColor5 || tenantData?.theme?.themecolor5,
  headerBgOverride:   tenantData?.header?.bgColor,
  headerTextOverride: tenantData?.header?.textColor,
  footerBgOverride:   tenantData?.footer?.bgColor,
  footerTextOverride: tenantData?.footer?.textColor,
  headingFont: tenantData?.branding?.headingFont || 'Poppins',
  bodyFont:    tenantData?.branding?.bodyFont    || 'Inter',
  heroData:    tenantData?.hero,
  aboutUs:     tenantData?.aboutUs,
  contactUs:   tenantData?.contactUs,
  activeModules: tenantData?.activeModules,
});

export const getB2CColors_T62 = (landingData) => {
  const teal    = landingData?.themeColor1 || '#1F3651';
  const darkBg  = landingData?.themeColor2 || '#0c4a6e';
  const headerBg= landingData?.themeColor3 || '#ffffff';
  const yellow  = landingData?.themeColor4 || '#f59e0b';
  const pageBg  = landingData?.themeColor5 || '#f1f5f9';

  return {
    theme1: teal,
    theme2: landingData?.footerBgOverride || darkBg,
    theme3: landingData?.headerBgOverride || headerBg,
    theme4: yellow,
    theme5: pageBg,
    teal, yellow, dark: '#1e293b', pageBg,
    headerText: landingData?.headerTextOverride || '#1e293b',
    footerText: landingData?.footerTextOverride || '#cbd5e1',
  };
};

export const toRgba = (color, alpha = 1) => {
  if (!color || !color.startsWith('#')) return color;
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
